module.exports = __webpack_public_path__ + "static/img/VG.e3b3a58f.png";